export default "__VITE_ASSET__cq8DJHR2__"